function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMarina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6256 1.39689C10.6256 0.979799 10.047 0.846374 9.85384 1.21894L4.04405 12.4268C3.9076 12.69 4.10467 13.0005 4.40818 13.0005H10.2174C10.4426 13.0005 10.6251 12.8233 10.6251 12.6047L10.6256 1.39689Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7723 7.17601C11.7723 6.74613 12.3789 6.6245 12.5542 7.01922L14.9662 12.4477C15.0823 12.709 14.885 13.0003 14.5919 13.0003H12.1802C11.955 13.0003 11.7725 12.8231 11.7725 12.6045L11.7723 7.17601Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12195 14.0005C1.0546 14.0005 1 14.0551 1 14.1224C1 16.8165 3.18398 19.0005 5.87805 19.0005H14.122C16.816 19.0005 19 16.8165 19 14.1224C19 14.0551 18.9454 14.0005 18.878 14.0005H1.12195Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarina);
export default __webpack_public_path__ + "static/media/icon-marina.1337a5ff30977264ade6a91dfbd44d6a.svg";
export { ForwardRef as ReactComponent };